import { render, staticRenderFns } from "./CertificateDelivery_list.vue?vue&type=template&id=54d351cc&scoped=true"
import script from "./CertificateDelivery_list.vue?vue&type=script&lang=js"
export * from "./CertificateDelivery_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d351cc",
  null
  
)

export default component.exports